import * as React from 'react'

import { IEditorContext } from 'components/RichTextEditor/types'

export const EditorContext = React.createContext<IEditorContext>({} as IEditorContext)

export const EditorContextProvider = EditorContext.Provider

export const WithEditorContext =
  <P extends UnsafeAnyObject>(
    Component: React.ComponentType<P>,
  ): React.FunctionComponent<Omit<P, keyof IEditorContext>> =>
  (props) =>
    (
      <EditorContext.Consumer>
        {(editorContext) => editorContext && <Component {...(props as P)} {...editorContext} />}
      </EditorContext.Consumer>
    )
